import { render, staticRenderFns } from "./AddOtherUsers.vue?vue&type=template&id=b9b66728&"
import script from "./AddOtherUsers.vue?vue&type=script&lang=js&"
export * from "./AddOtherUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports